export default {
  name: "ZoomIn",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M18 13c0 .55-.45 1-1 1h-3v3c0 .55-.45 1-1 1s-1-.45-1-1v-3H9c-.55 0-1-.45-1-1s.45-1 1-1h3V9c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1zm11.71 16.71a.996.996 0 0 1-1.41 0l-8.26-8.26A10.982 10.982 0 0 1 13 24C6.93 24 2 19.07 2 13S6.93 2 13 2s11 4.93 11 11c0 2.67-.96 5.13-2.55 7.03l8.26 8.26c.39.39.39 1.03 0 1.42zM13 22c4.96 0 9-4.04 9-9s-4.04-9-9-9-9 4.04-9 9 4.04 9 9 9z",
  },
}
